import type { ModerationState } from '@/features/moderation/types'

/**
 * Состояние блока обновления живого курса — ключ для плавной смены наполнения
 * (`SmoothHeight`): изменения → проверка → итог в ОДНОМ месте окна. `null` —
 * курс не живой или показывать нечего (тогда и обёртки нет: пустой блок занял
 * бы отступ в колонке окна).
 */
export const liveStatusKey = (m: ModerationState): string | null => {
  if (m.visibility === 'unpublished') return null
  const r = m.review
  if (r?.status === 'pending') return 'pending'
  if (m.hasUnsubmittedChanges) {
    if (r?.kind === 'update' && (r.status === 'rejected' || r.status === 'failed')) return r.status
    return m.draftId !== null ? 'changes' : null
  }
  return r?.status === 'approved' && r.kind === 'update' ? 'approved' : null
}
